import styled from '@emotion/styled';
import {
  fonts,
  media,
  pxToCssFont,
  pxToRem,
  sunriseSemanticTokens,
  sunriseSemanticTokens as theme,
} from '@vfit/shared/themes';

export const OfferCardContainer = styled.div`
  background-color: ${theme.colors.bg.primary};
  border: 1px solid ${theme.colors.border.default};
  border-radius: 20px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;

  padding: ${theme.spacing.lg} ${theme.spacing.lg} ${theme.spacing.xl};

  ${media.tablet`
      padding: ${theme.spacing.lg} ${theme.spacing.xl} ${theme.spacing.xl};
  `}

  ${media.largeDesktop`
      padding:  ${theme.spacing.xl};
  `}
`;

export const OfferCategory = styled.div`
  color: ${sunriseSemanticTokens.colors.text.primary};
  font-family: ${fonts.vodafone};
  font-size: ${theme.typography.fontSize.body1};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: ${theme.typography.lineHeight.body1};
  text-transform: capitalize;
  text-align: left;
  margin: 0;
  margin-bottom: ${theme.spacing.sm};
  * {
    margin: 0;
  }
`;

export const PricesContainer = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: ${theme.spacing.xs};
  gap: ${theme.spacing.xs};

  * {
    margin: 0;
  }
`;

export const Price = styled.p`
  color: ${sunriseSemanticTokens.colors.text.primary};
  font-family: ${fonts.vodafone};
  font-size: ${pxToRem(30)};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.extrabold};
  line-height: ${pxToRem(38)};

  ${media.largeDesktop`
      font-size: ${pxToRem(44)};
      line-height: ${pxToRem(52)};
    `}

  .rec {
    color: ${sunriseSemanticTokens.colors.text.primary};
    font-family: ${fonts.vodafone};
    font-size: ${pxToRem(30)};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.extrabold};
    line-height: ${pxToRem(38)};

    ${media.largeDesktop`
        font-size: ${theme.typography.fontSize.display4}; 
        line-height: ${theme.typography.lineHeight.h1}; 
      `}
  }
`;

export const ProductSubPrice = styled.p`
  color: ${sunriseSemanticTokens.colors.text.secondary};
  display: flex;
  align-items: center;
  ${pxToCssFont(18, 24)};
  margin: 0;
  margin-bottom: ${theme.spacing.sm};

  * {
    margin: 0;
  }

  ${media.tablet`
    ${pxToCssFont(16, 22)};
  `}
`;

export const SubDescription = styled.p`
  color: ${sunriseSemanticTokens.colors.text.defaultSecondary1};
  font-family: ${fonts.vodafone};
  font-size: ${theme.typography.fontSize.body1};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.extrabold};
  line-height: ${theme.typography.lineHeight.body1};

  margin: 0;
  margin-bottom: ${theme.spacing.xs};

  * {
    margin: 0;
  }

  span {
    color: ${sunriseSemanticTokens.colors.text.primary};
    font-family: ${fonts.vodafone};
    font-size: ${theme.typography.fontSize.body1};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.regular};
    line-height: ${pxToRem(26)};
    margin-bottom: ${theme.spacing.sm};
  }
`;

// --------OFFER SPECIFICATIONS (SHOPPING CART (ARRAY FOR PRODUCTS CMS / OBJ FOR TECHNOLOGY CMS) ) -------

export const ShoppingCartListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${theme.spacing.md};
  align-self: stretch;
  margin-top: ${theme.spacing.xl};

  ${media.largeDesktop`
      margin-top: ${theme.spacing.lg}
    `};
`;

export const ShoppingCartItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  gap: ${pxToRem(12)};
`;

export const ShoppingCartItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${pxToRem(18)};
  height: ${pxToRem(26)};
`;

export const ShoppingCartItemContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  flex: 1;
`;

export const ShoppingCartItemTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  gap: ${pxToRem(8)};
`;

export const ShoppingCartItemTitle = styled.div`
  color: ${sunriseSemanticTokens.colors.text.primary};
  font-family: ${fonts.vodafone};
  font-size: ${theme.typography.fontSize.h6};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: ${theme.typography.lineHeight.h6};

  ${media.largeDesktop`
      font-size: ${pxToRem(22)};
      line-height: ${pxToRem(32)}; 
    `}
`;

export const ShoppingCartItemDescription = styled.div`
  color: ${sunriseSemanticTokens.colors.text.primary};
  font-family: ${fonts.vodafone};
  font-size: ${theme.typography.fontSize.h6};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.regular};
  line-height: ${theme.typography.lineHeight.h6};

  margin: 0;
  * {
    margin: 0;
  }

  ${media.largeDesktop`
      font-size: ${pxToRem(22)};
      line-height: ${pxToRem(32)}; 
    `}
`;

